import { ROLES } from 'src/constants/roles';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { WarningPopover } from 'src/components/WarningPopower/WarningPopover';
import { DeleteProjectModal } from 'src/pages/ProjectPage/ProjectInfoSection/DeleteProjectModal';
import { Button } from 'src/components/ui/button';
import { clsx } from 'clsx';
import { ProjectSettingsModal } from './ProjectSettingsModal/ProjectSettingsModal';

export const ProjectControlsComponent = () => {
  const { data: userInfo } = useGetUsersMeQuery();

  const isCosupportManager =
    userInfo?.role === ROLES.COSSUPORT_MANAGER || userInfo?.role === ROLES.ADMIN;

  return (
    <div className="relative flex md:gap-2.5 gap-2 items-center">
      <div className="add-button-container relative flex md:gap-2.5 gap-2">
        <ProjectSettingsModal disabled={!isCosupportManager} />
        {!isCosupportManager && (
          <WarningPopover triggerClassName="absolute -right-2 -top-2" fill="black" />
        )}
      </div>
      <div className="add-button-container relative flex md:gap-2.5 gap-2">
        <DeleteProjectModal
          trigger={
            <Button
              variant="outline"
              className={clsx(
                !isCosupportManager && 'pointer-events-none opacity-50',
                'flex gap-2',
              )}
            >
              <p className="font-medium text-base-xs">Delete</p>
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.75 15V3.33333H1V1.77778H4.75V1H9.25V1.77778H13V3.33333H12.25V15H1.75ZM3.25 13.4444H10.75V3.33333H3.25V13.4444ZM4.75 11.8889H6.25V4.88889H4.75V11.8889ZM7.75 11.8889H9.25V4.88889H7.75V11.8889Z"
                  fill="#05050D"
                  fillOpacity="0.8"
                  stroke="white"
                  strokeWidth="0.2"
                />
              </svg>
            </Button>
          }
          disabled={!isCosupportManager}
        />
        {!isCosupportManager && (
          <WarningPopover triggerClassName="absolute -right-2 -top-2" fill="black" />
        )}
      </div>
    </div>
  );
};
